<template>
  <div class="wg-row">
    <div
      :class="[
        'wg-col',
        'wg-xs-12',
        contactId === null ? 'wg-sm-12 wg-md-12' : 'wg-sm-3 wg-md-3',
      ]"
      v-show="contactId === null || windowWidth > 767"
    >
      <wg-modal
        v-if="openModal"
        :width="windowWidth > 700 ? '700px' : '90%'"
        @closeModal="
          openModal = false;
          openEditFeedModal = false;
        "
        :confirmOnClose="true"
        :confirmOnCloseMsg="
          openEditFeedModal
            ? $anm22.strLang(
                lang,
                'Cancel changes to the feed?',
                'Annullare modifiche al feed?'
              )
            : $anm22.strLang(
                lang,
                'Cancel adding a new feed?',
                'Annullare aggiunta feed?'
              )
        "
      >
        <div class="com-anm22-app-text-l" slot="header">
          {{
            openEditFeedModal
              ? $anm22.strLang(lang, "Edit", "Modifica")
              : $anm22.strLang(lang, "Add content", "Aggiungi elemento")
          }}
        </div>
        <new-feed-dialog
          v-if="openEditFeedModal"
          slot="body"
          :contactId="contactSel"
          :edit="true"
          :onlyReminderView="selectedMsg.data.type == 'reminder' ? true : false"
          :changeStatusView="selectedMsg.type == 7 ? true : false"
          :msgRef="selectedMsg"
        ></new-feed-dialog>
        <new-feed-dialog
          v-else
          slot="body"
          :isReferentReminder="true"
          :contactId="contactSel"
          :msgRef="msg"
        ></new-feed-dialog>
      </wg-modal>
      <!-- <wg-modal
        v-if="openNewFeedModal"
        :width="windowWidth > 700 ? '700px' : '90%'"
        @closeModal="openNewFeedModal = false"
        :confirmOnClose="true"
        :confirmOnCloseMsg="
          $anm22.strLang(
            lang,
            'Cancel adding a new feed?',
            'Annullare aggiunta feed?'
          )
        "
      >
        <div class="com-anm22-app-text-l" slot="header">
          {{ $anm22.strLang(lang, "Add content", "Aggiungi elemento") }}
        </div>
        <new-feed-dialog
          slot="body"
          :isReferentReminder="true"
          :contactId="contactSel"
          :msgRef="msg"
        ></new-feed-dialog>
      </wg-modal> -->
      <wg-modal
        :width="windowWidth > 700 ? '300px' : '80%'"
        v-if="sortingModalStatus"
        @closeModal="closeSortingModal()"
      >
        <div
          class="wg-row"
          slot="header"
          style="flex-wrap: nowrap; align-items: center"
        >
          <div class="com-anm22-app-text-xl" slot="header">
            {{ $anm22.strLang(lang, "Order", "Ordinamento") }}
          </div>
        </div>
        <div slot="body">
          <div
            class="wg-row cont"
            style="
              align-items: center;
              flex-wrap: nowrap;
              margin-bottom: 10px;
              position: relative;
            "
            v-for="(f, index) in orderingContactsFields"
            @click="
              orderingContactsField = f.field;
              changeOrderingContactsField();
            "
            :key="'field-contact' + index"
          >
            <div :style="{ fontSize: '15px', marginLeft: '8px' }">
              {{ f.label }}
            </div>
            <div class="cont-tick" v-if="orderingContactsField == f.field">
              <img
                style="width: 20px"
                :src="$anm22.icons.getWorldIcon('tick')"
              />
            </div>
          </div>
        </div>
      </wg-modal>
      <div class="contacts-list-header">
        <img
          class="work-img"
          :src="
            $anm22.getObjIcon(
              $store.getters['works/get'](workSelected),
              'workDefault'
            )
          "
        />
        <div class="name">
          {{ $store.getters["works/get"](workSelected).name }}
        </div>
        <a
          :href="selectWorkUrl"
          ><img
            class="change-work"
            :src="$anm22.icons.getWorldIcon('menuSwitch')"
        /></a>
        <img
          @click="$emit('openModalViews')"
          class="change-view"
          :src="$anm22.icons.getWorldIcon('viewLastEvents')"
        />
        <img
          @click="openSortingModal()"
          class="sort-modal"
          :src="$anm22.icons.getWorldIcon('sort')"
        />
      </div>
      <div
        class="wg-row"
        style="
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          height: 36px;
        "
      >
        <select
          style="max-width: 200px; margin-left: 10px"
          class="com-anm22-app-select"
          v-model="userSelected"
        >
          <option
            v-for="(user, index) in users"
            :key="'user-' + index"
            :value="user.idWorldUser"
          >
            {{ user.name + " " + user.surname }}
          </option>
        </select>
        <template v-if="filters.length > 0">
          <div
            v-for="(filter, index) in filters"
            :key="'filter-' + index"
            class="display-flex filter-button"
            @click="$emit('remove-filter', index)"
          >
            <img
              class="com-anm22-app-img-fixed-height-s"
              :src="$anm22.icons.getWorldIcon('deleteBlack')"
              style="margin-right: 10px"
            />
            <div class="com-anm22-app-text-m">{{ filter.name }}</div>
          </div>
        </template>
      </div>
      <div class="vertical-height-div" style="height: 4px"></div>
      <div
        class="contacts-cont com-anm22-app-scrolling-panel"
        style="padding: 10px"
      >
        <div
          v-if="contactsByReferent.length > 0"
          style="float: left; width: 250px"
          class="contact-box"
        >
          <div class="wg-row" style="padding: 10px">
            <div style="width: 250px; height: 26px">
              <div class="wg-row desc-label" style="justify-content: center">
                <span class="name-label">{{
                  $anm22.strLang(lang, "Name (" + contactsByReferent.length + ")", "Nome (" + contactsByReferent.length + ")")
                }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="wg-row" style="padding: 10px">
            <div style="width: 240px">
              <div class="wg-row desc-label" style="justify-content: center">
                <span class="name-label">{{ "Nome" }}</span>
              </div>
            </div>
          </div> -->
          <div
            v-for="(contact, index) in contactsByReferent"
            :ref="'contact-' + contact.idContactsContact"
            :key="'full-contact-' + index"
            :class="['wg-row', 'main-row']"
          >
            <router-link
              :to="'/contact/' + (contact.idContactsContact)"
            >
              <div
                style="cursor: pointer; width: 250px"
                :class="[
                  'wg-row',
                  'item ',
                  reminderClass(contact),
                  contact.lastOpen < contact.lastFeedUpdate ? 'to-read' : '',
                  contactId == contact.idContactsContact ? 'selected' : ''
                ]"
                >
                <div class="container">
                  <img
                    :src="
                      contact.type == 2
                        ? $anm22.getObjIcon(contact, 'workMaterial')
                        : $anm22.getContactIcon(contact, $store)
                    "
                    class="image"
                  />
                </div>
                <div class="wg-row">
                  <div class="wg-row name">
                    {{ $anm22.getContactName(contact, $store) }}
                    <span v-if="$anm22.getReferrerFlag(contact, $store) == 0">{{ $anm22.getContactReferrerName(contact, $store) }}</span>
                    <img
                      v-if="!isSynchronized(contact.idContactsContact)"
                      class="com-anm22-app-img-fixed-height-s"
                      :src="$anm22.icons.getWorldIcon('offline')"
                      style="margin-left: 5px"
                      :title="
                        $anm22.strLang(
                          lang,
                          'Not synchronized',
                          'Non sincronizzato'
                        )
                      "
                    />
                  </div>
                  <div
                    v-if="contact.lastFeedDate"
                    class="contact-last-feed"
                    :title="$anm22.strLang(lang, 'Last feed', 'Ultimo feed')"
                  >
                    {{ contact.lastFeedDate | moment("DD-MM-YYYY HH:mm") }}
                  </div>
                  <div
                    v-if="
                      contact.pauseDate &&
                      contact.pauseDate > Math.floor(Date.now() / 1000)
                    "
                    class="contact-pause"
                    :title="$anm22.strLang(lang, 'Pause', 'Contatto in pausa')"
                  >
                    {{ contact.pauseDate | moment("DD-MM-YYYY") }}
                  </div>
                  <div
                    v-if="contact.value && contact.value != 0"
                    class="contact-value"
                    :title="$anm22.strLang(lang, 'Lead value', 'Valore lead')"
                  >
                    {{ contact.value }}
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div
          :class="[
            windowWidth < 767 || contactId != null
              ? ''
              : 'com-anm22-app-scrolling-panel',
            'contacts-list-container',
          ]"
        >
          <div v-if="contactsByReferent.length > 0" class="contact-box">
            <div class="wg-row" style="padding: 10px">
              <div style="width: 200px">
                <div class="wg-row desc-label" style="justify-content: center">
                  <span class="name-label">{{
                    $anm22.strLang(lang, "Work/Referents", "Azienda/Referenti")
                  }}</span>
                </div>
              </div>
              <div
                class="com-anm22-app-horizontal-space"
                style="width: 10px"
              ></div>
              <div style="width: 200px">
                <div class="wg-row desc-label" style="justify-content: center">
                  <span class="name-label">{{
                    $anm22.strLang(lang, "Contact status", "Stato contatto")
                  }}</span>
                </div>
              </div>
              <div style="margin: 0 auto">
                <b style="vertical-align: middle">
                  <span
                    style="margin-right: 5px; cursor: pointer"
                    @click="prevWeek()"
                    >&lt;</span
                  >
                  <span>{{ week.format("MMMM YY").toUpperCase() }}</span>
                  <span
                    style="margin-left: 5px; cursor: pointer"
                    @click="nextWeek()"
                    >&gt;</span
                  >
                </b>
                <div @click="returnToday()" class="today-label">
                  <div class="name">
                    {{ $anm22.strLang(lang, "Today", "Oggi") }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-for="(contact, index) in contactsByReferent"
              :ref="'contact-' + contact.idContactsContact"
              :key="'full-contact-' + index"
              :class="['wg-row', 'main-row']"
            >
              <!-- <div
            style="cursor: pointer; width: 300px"
            :class="[
              'wg-row',
              'item ',
              contact.lastOpen < contact.lastFeedUpdate ? 'to-read' : '',
            ]"
            @click="$router.push({ path: `/contact/${contact.idContactsContact}` });"
          >
            <div class="container">
              <img
                :src="
                  contact.type == 2
                    ? $anm22.getObjIcon(contact, 'workMaterial')
                    : $anm22.getContactIcon(contact, $store)
                "
                class="image"
              />
            </div>
            <div class="wg-row">
              <div class="wg-row name">
                {{ $anm22.getContactName(contact, $store) }}
                <img
                  v-if="!isSynchronized(contact.idContactsContact)"
                  class="com-anm22-app-img-fixed-height-s"
                  :src="$anm22.icons.getWorldIcon('offline')"
                  style="margin-left: 5px"
                  :title="
                    $anm22.strLang(
                      lang,
                      'Not synchronized',
                      'Non sincronizzato'
                    )
                  "
                />
              </div>
              <div
                v-if="contact.lastFeedDate"
                class="contact-last-feed"
                :title="$anm22.strLang(lang, 'Last feed', 'Ultimo feed')"
              >
                {{ contact.lastFeedDate | moment("DD-MM-YYYY HH:mm") }}
              </div>
              <div
                v-if="
                  contact.pauseDate &&
                  contact.pauseDate > Math.floor(Date.now() / 1000)
                "
                class="contact-pause"
                :title="$anm22.strLang(lang, 'Pause', 'Contatto in pausa')"
              >
                {{ contact.pauseDate | moment("DD-MM-YYYY") }}
              </div>
              <div
                v-if="contact.value && contact.value != 0"
                class="contact-value"
                :title="$anm22.strLang(lang, 'Lead value', 'Valore lead')"
              >
                {{ contact.value }}
              </div>
            </div>
          </div> -->
              <div
                class="com-anm22-app-horizontal-space"
                style="width: 10px"
              ></div>
              <div
                :class="['wg-row', 'item', 'com-anm22-app-scrolling-panel']"
                :style="{
                  width: '200px',
                  whiteSpace: 'nowrap',
                  flexWrap:
                    contact.type == 2 && companyContacts(contact).length > 1
                      ? 'wrap'
                      : '',
                }"
              >
                <div class="wg-row">
                  <template v-if="contact.type == 2">
                    <template v-if="companyContacts(contact).length > 0">
                      <template v-for="(c, index) in companyContacts(contact)">
                        <div
                          @click="$router.push({ path: `/contact/${c.idContactsContact}` });"
                          :key="index"
                          class="wg-row name"
                          style="justify-content: center; cursor: pointer"
                        >
                          {{ $anm22.getContactName(c, $store) }}
                        </div>
                      </template>
                    </template>
                    <template v-else>
                      <div class="wg-row name" style="justify-content: center">
                        {{
                          $anm22.strLang(
                            lang,
                            "No referents",
                            "Nessun referente"
                          )
                        }}
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div class="wg-row name" style="justify-content: center">
                      {{ contactCompanyDescription(contact) }}
                    </div>
                  </template>
                </div>
              </div>
              <div
                class="com-anm22-app-horizontal-space"
                style="width: 10px"
              ></div>
              <div :class="['wg-row', 'item ']" style="width: 200px">
                <div class="wg-row">
                  <div
                    class="wg-row name"
                    style="justify-content: center; align-items: center"
                  >
                    <select
                      v-if="
                        viewSelectStatus &&
                        viewSelectStatus == contact.idContactsContact
                      "
                      style="width: 150px"
                      class="input-elem com-anm22-app-select"
                      v-model="statusSelected"
                      @change="changeStatus(contact)"
                    >
                      <option value>
                        {{ $anm22.strLang(lang, "No status", "Nessuno stato") }}
                      </option>
                      <option
                        v-for="(status, index) in orderedContactsStatusList"
                        :key="'status-' + index"
                        :value="status.idContactsContactStatus"
                      >
                        {{ status.name }}
                      </option>
                    </select>
                    <span
                      v-else
                      class="name"
                      style="padding:1px 1px 1px 5px;text-align:center;"
                      :style="{
                        borderLeft:
                          $store.getters['contactsStatus/get'](
                            contact.status
                          ) &&
                          $store.getters['contactsStatus/get'](contact.status)
                            .color != ''
                            ? '3px solid' +
                              ' ' +
                              $store.getters['contactsStatus/get'](
                                contact.status
                              ).color
                            : '',
                      }"
                      >{{
                        $store.getters["contactsStatus/get"](contact.status)
                          ? $store.getters["contactsStatus/get"](
                              contact.status
                            ).name.toUpperCase()
                          : $anm22.strLang(lang, "No status", "Nessuno stato")
                      }}</span
                    >
                    <img
                      @click="changeMode(contact)"
                      class="change-status"
                      :title="
                        $anm22.strLang(lang, 'Change status', 'Cambia stato')
                      "
                      :src="$anm22.icons.getWorldIcon('edit')"
                    />
                  </div>
                </div>
              </div>
              <div
                class="com-anm22-app-horizontal-space"
                style="width: 10px"
              ></div>
              <div :class="['wg-row', 'item']" style="padding: 0; width: auto">
                <div class="calendar__week">
                  <div
                    v-for="(element, index) in calendar(contact)"
                    :key="index"
                    class="calendar__day day com-anm22-app-scrolling-panel"
                    @click="
                      openEditFeedModal
                        ? ''
                        : newReminder(element.day, contact.idContactsContact)
                    "
                  >
                    <span>{{ element.day.format("DD ddd") }}</span>
                    <div
                      v-for="(row, index) in element.rows"
                      :key="'msg-' + index"
                      :class="[
                        'msg-body',
                        row.type == 7
                          ? ''
                          : row.data.type == 'reminder'
                          ? 'reminder'
                          : '',
                      ]"
                      :title="
                        row.type == 7
                          ? changeStatusLabel(
                              row.data.fromStatus,
                              row.data.toStatus
                            )
                          : nameByType(row)
                      "
                      @click="editReminder(row, contact.idContactsContact)"
                    >
                      <div v-if="row.type == 7">
                        {{
                          changeStatusLabel(
                            row.data.fromStatus,
                            row.data.toStatus
                          )
                        }}
                        {{ row.data.name }}
                      </div>
                      <div v-else>
                        {{ nameByType(row) }}
                      </div>
                      <template v-if="row.type == ''">
                        <div
                          v-if="row.createdBy"
                          class="wg-row"
                          style="justify-content: flex-end"
                        >
                          <img
                            :src="
                              $anm22.getObjIcon(
                                $store.getters['users/get'](row.createdBy),
                                'userDefault'
                              )
                            "
                            :title="
                              $store.getters['users/get'](row.createdBy).name +
                              ' ' +
                              $store.getters['users/get'](row.createdBy).surname
                            "
                            class="anm22-calendar-icon-inline anm22-calendar-round event-img"
                          />
                        </div>
                      </template>
                      <template v-else>
                        <div
                          v-if="row.user"
                          class="wg-row"
                          style="justify-content: flex-end"
                        >
                          <img
                            :src="
                              $anm22.getObjIcon(
                                $store.getters['users/get'](row.user),
                                'userDefault'
                              )
                            "
                            :title="
                              $store.getters['users/get'](row.user).name +
                              ' ' +
                              $store.getters['users/get'](row.user).surname
                            "
                            class="anm22-calendar-icon-inline anm22-calendar-round event-img"
                          />
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="vertical-height-div" style="height: 20px"></div>
            <div class="wg-row no-available">
              {{
                $anm22.strLang(
                  lang,
                  "No contacts available",
                  "Nessun contatto disponibile"
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="contactId != null">
      <div v-if="windowWidth > 767" class="bar-div">
        <div @click="resetContact" class="bar-select"></div>
      </div>
      <div
        class="wg-col wg-xs-12 wg-sm-9 wg-md-9"
        :style="{
          borderLeft: '1px solid #eee',
          width: windowWidth > 767 ? 'calc(75% - 8px)' : '',
          height: 'calc(100vh - 60px)',
        }"
      >
        <contact
          :view="view"
          :contactId="contactId"
          @reset="resetContact"
        ></contact>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import WorldContactForm from "../../../../../world/spa/components/WorldContactForm.vue";
import Contact from "../Contact.vue";
import NewFeedDialog from "../NewFeedDialog.vue";

export default {
  props: {
    contacts: Array,
    filters: Array,
    view: String,
    reminderClass: Function,
    sortingModalStatus: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      openModal: false,
      viewSelectStatus: null,
      statusSelected: null,
      isChangeStatus: false,
      openEditFeedModal: false,
      selectedMsg: null,
      msg: null,
      weekOffset: 0,
      contactSel: null,
      openNewFeedModal: false,
      userSelected: null,
      now: this.$moment(),
      orderingContactsField:
        this.$anm22.getCookie("contacts_cols_ordering") !== ""
          ? this.$anm22.getCookie("contacts_cols_ordering")
          : "lastFeedDate",
    };
  },
  watch: {
    userSelected(newVal, old) {
      this.getFeeds();
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
      workSelected: (state) => state.workSelected,
    }),
    contactsStatus() {
      return this.$store.getters["contactsStatus/getByWork"](this.workSelected);
    },
    orderedContactsStatusList() {
      var status = this.contactsStatus;
      status.sort(function (a, b) {
        if (a.level < b.level) {
          return -1;
        } else if (a.level > b.level) {
          return 1;
        } else {
          return 0;
        }
      });
      return status;
    },
    userPermission() {
      return this.$store.getters["employments/getPermByWork"](
        this.workSelected
      );
    },
    users() {
      let users = [];
      users.push(this.user.idWorldUser);
      let employments = this.$store.getters["employments/getAll"].filter(
        (e) => e.work == this.workSelected
      );
      employments.forEach((emp) => {
        if (this.userPermission <= 3) {
          users.push(emp.user);
        } else {
          let userEmployment = this.$store.getters["employments/get"](
            emp.user + "-" + this.workSelected
          );
          if (userEmployment.accountable == this.user.idWorldUser) {
            users.push(emp.user);
          }
        }
      });
      //Con new set elimino le ripetizioni
      users = [...new Set(users)];
      users = users.map((u) => this.$store.getters["users/get"](u));
      return users;
    },
    contactsByReferent() {
      //Filtro i contatti per work e utente
      let contacts = this.contacts.filter(
        (c) =>
          c.referenceAgent == this.userSelected &&
          c.workOwner == this.workSelected
      );

      //Copia array contatti
      let contactsToCicle = contacts.slice(0);
      //Ciclo i contatti
      contactsToCicle.forEach((c) => {
        //Se il contatto è una persona,cerco l'azienda associata,se la trovo,la inserisco e elimino dall'array la persona
        if (c.type != 2) {
          if (this.workContact(c)) {
            contacts.push(this.workContact(c));
            contacts.splice(
              contacts.findIndex(
                (contact) => contact.idContactsContact == c.idContactsContact
              ),
              1
            );
          }
        }
      });
      //Elimino eventuali doppioni
      return contacts
        .filter(
          (contact, index, arrayResult) =>
            arrayResult.findIndex(
              (r) => r.idContactsContact === contact.idContactsContact
            ) === index
        )
        .sort(this.sortingContacts);
    },
    sortingContacts() {
      return (a, b) => {
        if (this.orderingContactsField == "lastFeedDate") {
          if (a.lastFeedDate < b.lastFeedDate) {
            return 1;
          } else if (a.lastFeedDate > b.lastFeedDate) {
            return -1;
          } else {
            return 0;
          }
        }
        if (this.orderingContactsField == "ascValue") {
          if (a.value > b.value) {
            return 1;
          } else if (a.value < b.value) {
            return -1;
          } else {
            return 0;
          }
        }
        if (this.orderingContactsField == "descValue") {
          if (a.value < b.value) {
            return 1;
          } else if (a.value > b.value) {
            return -1;
          } else {
            return 0;
          }
        }
        if (this.orderingContactsField == "colorPriority") {
          if (a.priority < b.priority) {
            return 1;
          } else if (a.priority > b.priority) {
            return -1;
          } else {
            return 0;
          }
        }
      };
    },
    orderingContactsFields() {
      return [
        {
          field: "lastFeedDate",
          label: this.$anm22.strLang(
            this.lang,
            "Last interaction",
            "Ultima interazione"
          ),
        },
        {
          field: "ascValue",
          label: this.$anm22.strLang(
            this.lang,
            "Lead value - Increasing",
            "Valore lead - Crescente"
          ),
        },
        {
          field: "descValue",
          label: this.$anm22.strLang(
            this.lang,
            "Lead value - Decreasing",
            "Valore lead - Decrescente"
          ),
        },
        {
          field: "colorPriority",
          label: this.$anm22.strLang(this.lang, 'Last reminder', 'Ultimo reminder'),
        }
      ];
    },
    contactId() {
      return this.$store.getters["getContactSelected"];
    },
    week() {
      return this.now.clone().add(this.weekOffset, "weeks");
    },
    contactsChannelsId() {
      let channels = this.contactsByReferent.map((c) => c.feed);
      return channels;
    },
    isReferrerEmpty() {
      if((!this.contact.referrerFirstName && !this.contact.referrerLastName)
         || (this.contact.referrerFirstName === '' && this.contact.referrerLastName === '')){
        return true
      }
      return false;
    },
    selectWorkUrl() {
      return (process.env.NODE_ENV === 'production' ? 'https://www.anm22.it' : process.env.VUE_APP_FRONT_DOMAIN) + '/app/work/selectWork?nullOption=1&cbSucc=..%2Fcontacts-v%2F';
    },
  },
  methods: {
    statusChangedText(contact) {
      let text = "";
      //VECCHIO STATO
      let fromStatus = this.$store.getters["contactsStatus/get"](
        contact.status
      );
      //STATO SELEZIONATO
      let toStatus = this.$store.getters["contactsStatus/get"](
        this.statusSelected
      );
      if (!fromStatus && toStatus) {
        text = this.$anm22.strLang(
          this.lang,
          "Contact added to" + " " + toStatus.name,
          "Contatto aggiunto in" + " " + toStatus.name
        );
      } else if (fromStatus && !toStatus) {
        text = this.$anm22.strLang(
          this.lang,
          "Contact status removed ",
          "Stato del contatto rimosso"
        );
      } else if (fromStatus && toStatus) {
        text = this.$anm22.strLang(
          this.lang,
          "Contact status changed to" + " " + toStatus.name,
          "Lo stato del contatto è cambiato in" + " " + toStatus.name
        );
      }
      return text;
    },
    async changeStatus(contact) {
      let msgData = {
        text: this.statusChangedText(contact),
        description: "",
        type: "changeStatus",
        contentType: "plain",
        fromStatus: contact.status,
        toStatus: this.statusSelected,
      };
      try {
        const response = await this.$http.post(
          "contact/change-status",
          {
            contactId: contact.idContactsContact,
            newStatus: this.statusSelected,
            msgData: msgData
          },
          {
            withCredentials: true
          }
        );
        this.$store.dispatch("contacts/update", {
          vlf: this.$vlf("contacts"),
          objs: [response.data.contact],
        });
        this.$store.dispatch("messages/update", {
          vlf: this.$vlf("messages"),
          objs: [response.data.message],
        });
        /* Messaggio creazione progetti */
        let engText = "";
        let itText = "";
        if(response.data.projects && response.data.projects.length > 0) {
          engText = " - Successfully created projects";
          itText = " - Progetti creati correttamente";
        }
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Contact status changed successfully" + engText,
            "Stato del contatto cambiato con successo" + itText
          ),
          type: "suggestion",
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.$anm22.eventBus.$emit('wg-modal-close');
      }
    },
    changeMode(contact) {
      if (
        this.viewSelectStatus &&
        this.viewSelectStatus == contact.idContactsContact
      ) {
        this.viewSelectStatus = null;
      } else {
        this.viewSelectStatus = contact.idContactsContact;
      }
      if (this.$store.getters["contactsStatus/get"](contact.status)) {
        this.statusSelected = contact.status;
      } else {
        this.statusSelected = "";
      }
    },
    resetContact() {
      this.$store.dispatch("selectContact", null);
      document.title = "ANM22 Contacts";
    },
    selectContact(contactId) {
      if (this.$store.getters["contacts/get"](contactId)) {
        if (contactId === this.contactId) {
          this.resetContact();
        } else {
          this.$store.dispatch("selectContact", contactId);
        }
      }
    },
    returnToday() {
      this.weekOffset = 0;
    },
    nameByType(row) {
      switch (row.data.type) {
        case "reminder":
          return row.data.name;
        case "call":
          return row.data.description;
        case "msg":
          return row.data.text;
        case "meeting":
          return row.data.description;
        case "actionMsg":
          return row.data.title;
      }
    },
    changeStatusLabel(fromStatus, toStatus) {
      let from = this.$store.getters["contactsStatus/get"](fromStatus);
      let to = this.$store.getters["contactsStatus/get"](toStatus);
      let label = "";
      if (to) {
        label = to.name;
      } else {
        label = "Nessuno stato";
      }
      return label;
    },
    editReminder(msg, contactId) {
      this.openEditFeedModal = true;
      this.openModal = true;
      this.contactSel = contactId;
      this.selectedMsg = { ...msg };
    },
    newReminder(date, contactId) {
      console.log("creazione");
      this.openEditFeedModal = false;
      this.openModal = true;
      this.contactSel = contactId;
      let d = date.format("YYYY-MM-DD");
      let time = this.$moment.unix(this.$moment().unix()).format("HH:mm");
      let newDate = Number(
        this.$moment(d + " " + time)
          .utc()
          .format("X")
      );
      this.msg = {
        data: {
          text: "",
          description: "",
          type: "reminder",
          contentType: "plain",
        },
        ts: newDate,
      };
    },
    workContact(contact) {
      if (contact.type != 2 && contact.company && contact.company != "") {
        return this.contacts.find(
          (c) =>
            c.type == 2 &&
            c.workOwner == contact.workOwner &&
            c.firstName.toUpperCase() == contact.company.toUpperCase()
        );
      }
    },
    companyContacts(contact) {
      if (contact.type == 2) {
        return this.contacts.filter(
          (c) =>
            c.company &&
            c.company != "" &&
            c.workOwner == contact.workOwner &&
            c.company.toUpperCase() == contact.firstName.toUpperCase()
        );
      } else {
        return [];
      }
    },
    contactCompanyDescription(contact) {
      let result = this.$anm22.strLang(
        this.lang,
        "No company",
        "Nessuna azienda"
      );
      if (contact.company && contact.company != "") {
        result = contact.company;
      }
      if (contact.type == 2) {
        result = contact.firstName;
      }
      return result;
    },
    getFeeds() {
      this.$http
        .post(
          "contacts/get-feeds",
          {
            channelsId: this.contactsChannelsId
          },
          {
            withCredentials: true
          }
        )
        .then((response) => {
          Promise.all([
            this.$store.dispatch("messageChannels/update", {
              vlf: this.$vlf("messageChannels"),
              objs: response.data.feeds,
            }),
            this.$store.dispatch("messages/update", {
              vlf: this.$vlf("messages"),
              objs: response.data.messages,
            }),
          ])
            .then(() => {})
            .catch((error) => console.log(error));
        });
    },
    loadData() {
      Promise.all([
        this.$store.dispatch(
          "messageChannels/load",
          this.$vlf("messageChannels")
        ),
        this.$store.dispatch("messages/load", this.$vlf("messages")),
      ])
        .then(() => {
          this.loading = false;
        })
        .catch((error) => console.log(error));
    },
    msgs(contact) {
      return contact.feed
        ? this.$store.getters["messages/getByChannel"](contact.feed).sort(
            (a, b) => a.ts - b.ts
          )
        : [];
    },
    calendar(contact) {
      //   let result = [];
      //   const startDay = this.week.clone().startOf("week");
      //   const endDay = this.week.clone().endOf("week");
      //   let date = startDay.clone().subtract(1, "day");
      let contactMsgs = this.msgs(contact);
      let matrix = [];
      // prendo il primo giorno della settimana al cui interno di trova l'inizio del mese
      const firstDay = this.week
        .clone()
        .utc()
        .startOf("week")
        .startOf("isoWeek");
      const lastDay = this.week.clone().utc().endOf("week").endOf("isoWeek");
      let selector = firstDay.clone();
      while (selector.isSameOrBefore(lastDay, "day")) {
        //Recupero i reminder di questo giorno
        const rows = contactMsgs.filter((msg) =>
          this.$moment.unix(msg.ts).utc().isSame(selector, "day")
        );
        //inserisco il giorno nella matrice
        matrix.push({
          day: selector.clone(),
          rows,
        });
        //incremento il giorno
        selector.add(1, "days");
      }
      return matrix;
    },
    prevWeek() {
      this.weekOffset--;
    },
    nextWeek() {
      this.weekOffset++;
    },
    isSynchronized(id) {
      return this.$store.getters["offline/isSynchronized"](
        this.$anm22.MD5("ContactsContact" + id)
      );
    },
    changeOrderingContactsField() {
      this.$anm22.setCookie(
        "contacts_cols_ordering",
        this.orderingContactsField,
        31536000
      );
    },
    openSortingModal() {
      this.$emit('changeSortingModalStatus', true);
    },
    closeSortingModal() {
      this.$emit('changeSortingModalStatus', false);
    },
    closeNewContactModal() {
      this.$emit('changeNewContactModalStatus', false);
    },
  },
  components: {
    "vue-simple-spinner": Spinner,
    WorldContactForm,
    Contact,
    NewFeedDialog,
  },
  created() {
    this.loadData();
    this.$http
      .post(
        "contacts/get-feeds",
        {
          channelsId: this.contactsChannelsId
        },
        {
          withCredentials: true
        }
      )
      .then((response) => {
        Promise.all([
          this.$store.dispatch("messageChannels/update", {
            vlf: this.$vlf("messageChannels"),
            objs: response.data.feeds,
          }),
          this.$store.dispatch("messages/update", {
            vlf: this.$vlf("messages"),
            objs: response.data.messages,
          }),
        ])
          .then(() => {
            this.userSelected = this.user.idWorldUser;
          })
          .catch((error) => console.log(error));
      });
  },
  mounted() {
    this.$nextTick(() => {
      this.updateInterval = setInterval(() => {
        //aggiorno i contatti
        this.getFeeds();
      }, 80000);
    });
    // this.$anm22.eventBus.$on("contact-selected", (id) => {
    //   this.resetFilters();
    //   this.selectContact(id);
    //   this.$nextTick(() => {
    //     this.$refs["contact-" + id][0].scrollIntoView();
    //   });
    // });
    // this.$anm22.eventBus.$on("contacts-filter", (f) => {
    //   this.filters.push({ name: f.name, fn: f.fn });
    // });
    // this.$nextTick(() => {
    //   this.updateInterval = setInterval(() => {
    //     //aggiorno i contatti
    //     this.getData();
    //   }, 120000);
    // });
  },
  destroyed() {
    // clearInterval(this.updateInterval);
    // this.$anm22.eventBus.$off("contact-selected");
    // this.$anm22.eventBus.$off("contacts-filter");
  },
};
</script>

<style lang="scss" scoped>
.ref-name {
  font-size: 13px;
}
.today-label {
  padding: 5px 10px;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  cursor: pointer;
  background-color: #ddd;
  border-radius: 20px;
  margin: 0 0 0 10px;
}
.today-label .name {
  font-size: 15px;
  color: #222;
}
.today-label:hover {
  background-color: #ccc;
}
.msg-body {
  cursor: pointer;
  padding: 3px;
  margin: 2px;
  border-radius: 5px;
  font-size: 12px;
  background-color: #fafafa;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 23px;
  &:hover {
    background-color: #ebebeb;
    border-color: #a8b2b9;
    color: #000000;
    height: auto;
  }
}
.msg-body.reminder {
  background-color: #666;
  color: white;
  border-color: #444;
  &:hover {
    background-color: #888;
    color: white;
    border-color: #666;
  }
}
.no-available {
  justify-content: center;
  font-size: 17px;
  opacity: 0.6;
}
.calendar__day {
  cursor: pointer;
  border-right: 1px solid #e1e1e1;
  border-left: 1px solid #e1e1e1;
  border-top: 1px solid #e1e1e1;
  border-bottom: 1px solid #e1e1e1;
  height: 70px;
  width: 98px;
  position: relative;
}
.calendar__week,
.calendar__header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.contacts-list-header {
  text-align: center;

  .name {
    display: inline-block;
    vertical-align: middle;
    padding: 12px 6px;
    font-size: 18px;
  }
  .change-view,
  .sort-modal,
  .change-work {
    opacity: 0.6;
    display: inline-block;
    vertical-align: middle;
    height: 20px;
    cursor: pointer;
    margin-left: 10px;
  }
  .work-img {
    display: inline-block;
    vertical-align: middle;
    border-radius: 10px;
    height: 20px;
    width: 20px;
  }
}
@media (min-width: 992px) {
  .contacts-list-header {
    .change-view,
    .sort-modal {
      display: none;
    }
  }
}
.contacts-cont {
  max-width: calc(100vw - 60px);
  max-height: calc(100vh - 175px);
}
.contacts-list-container {
  white-space: nowrap;
  box-sizing: border-box;
}
@media only screen and (max-width: 767px) {
  .contacts-cont {
    max-width: 100vw;
  }
}
.cont {
  position: relative;
  font-weight: normal;
  min-height: 15px;
  padding: 6px;
  border-radius: 10px;
  cursor: pointer;
}
.cont:hover {
  background-color: #eee;
}
.cont-tick {
  margin-left: auto;
}
.contact-box {
  display: inline-block;
  box-sizing: border-box;
  overflow-y: auto;
  white-space: normal;

  .desc-label {
    text-align: center;
    text-transform: uppercase;
    font-size: 14px;
    color: #444;
    font-weight: bold;

    .counter {
      font-weight: normal;
      color: #222;
      font-size: 12px;
    }
    .name-label {
      padding: 1px 1px 1px 5px;
      vertical-align: middle;
    }
  }
  .main-row {
    flex-wrap: nowrap;
    align-items: center;
    margin-top: 5px;
  }

  .item {
    flex-wrap: nowrap;
    align-items: center;
    height: 70px;
    padding: 10px;
    position: relative;
    background-color: #fff;
    border-radius: 7px;

    &.selectable {
      cursor: pointer;
    }
    &.selected {
      border-left : 2px solid #0aabf4;
    }

    .image {
      width: 40px;
      height: 40px;
      border: 1px solid #eee;
      border-radius: 20px;
      margin-right: 5px;
      //box-sizing:content-box;
    }
    &.blue .image {
      border: 2px solid #eee;
      border-color: #007fff!important ;
      border-image-width: 2px;
    }
    &.yellow .image {
      border: 2px solid #eee;
      border-color: #F6BE00!important;
      border-image-width: 2px;
    }
    &.red .image {
      border: 2px solid #eee;
      border-color: #f00!important ;
      border-image-width: 2px;
    }
    &.to-read .image {
      // background:
      // linear-gradient(#fff,#fff) padding-box,
      // linear-gradient(to left,#2145f3f5, #60aeeb) border-box;
      // color: #313149;
      border: 2px solid #eee;
      border-color: grey;
      border-image-width: 2px;
      //border: 2px solid transparent;
      // border-radius:20px;
      //display:inline-block;
      //margin: 75px 0;
    }

    .name {
      margin-bottom: 4px;

      span {
        margin-left: 2%;
      }
    }
    &.to-read .name {
      font-weight: bold;
    }
    .label {
      border-radius: 4px;
      background-color: #eee;
      font-size: 12px;
      color: #666;
      display: inline-block;
      padding: 2px 4px;
    }
    .contact-last-feed,
    .contact-value,
    .contact-pause {
      border-radius: 4px;
      font-size: 12px;
      color: #000;
      display: block;
      padding: 2px 4px 2px 13px;
      background-image: url(../../../../utilities/img/icons/chat-bubble.svg);
      background-size: 10px 10px;
      background-position: 0px center;
      background-repeat: no-repeat;
      opacity: 0.6;
    }
    .contact-value {
      background-image: url(../../../../../world/libs/anm22_icons/img/icons/cash.svg);
      background-size: 13px 13px;
      margin-right: 5px;
    }
    .contact-last-feed {
      background-image: url(../../../../utilities/img/icons/chat-bubble.svg);
      margin-right: 5px;
    }
    .contact-pause {
      padding: 2px 6px 2px 19px;
      background-position: 4px center;
      background-image: url(../../../../utilities/img/icons/pause.svg);
      background-color: #ddd;
    }
  }
}
.filter-button {
  flex-wrap: nowrap;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: #ddd;
  border-radius: 5px;
  padding: 6px;
  margin: 0 5px;
}
.bar-div {
  width: 8px;
  background-color: #555;
  position: relative;
}
.bar-select {
  width: 8px;
  height: 50px;
  border: 2px solid #555;
  border-radius: 5px;
  top: 50%;
  left: 0;
  right: 0;
  position: absolute;
  cursor: pointer;
  background-color: #aaa;
  &:hover {
    background-color: #bbb;
  }
}
.change-status {
  margin-bottom: 4px;
  opacity: 0.6;
  height: 17px;
  cursor: pointer;
  margin-left: 5px;
}
</style>